import { Badge, ErrorMessage, Paragraph, Spinner } from "../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../base/types";
import { IControlAttributes } from "../../../../base/models";
import { useParagraphProperties } from "./ParagraphProperties";

export const DraftParagraphComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, error, properties, draftText } = useParagraphProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                Paragraph
            </Badge>
            <Paragraph className={className} {...properties} text={draftText}>
                {children}
            </Paragraph>
        </div>)
}
